import React from 'react';

import { Skademeldingstype } from '../../../types/generated-types';
import { getExternalUrlForSkadetype } from '../../deep-link-handler';
import { eikaForsikringPhonenumber, LinkButton, phone } from '../utils';

const Yrkesskade = () => (
    <div>
        <p>
            For å melde yrkesskade eller yrkessykdom må du skrive ut skademelding. Skademeldingen skal fylles ut og
            signeres av arbeidsgiver og den ansatte i fellesskap. Her finner du skadeskjema:
        </p>
        <ul>
            <li>
                <a
                    href="https://eika.no/-/media/fellesfiler/forsikring/skadeskjema/Yrkesskade-sykdom-skademelding.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Yrkesskade/yrkessykdom
                </a>
            </li>
        </ul>

        <p>
            <strong>Utfylt skademelding legges ved når du logger inn og melder skade eller sendes per post til:</strong>
        </p>

        <p className="inline">Fremtind Forsikring</p>
        <p className="inline">Postboks 332</p>
        <p className="inline">2303 Hamar </p>
        <p>Ønsker du veiledning kan du kontakte oss på telefon: {phone(eikaForsikringPhonenumber)}</p>
        <LinkButton href={getExternalUrlForSkadetype(Skademeldingstype.PersonskadeAnnet)}>Meld skade</LinkButton>
    </div>
);

export default Yrkesskade;
